import $ from 'jquery';
import { isOperaMini, isRtl } from '../_shared/helpers';

/**
 * @desc Wrapper over Fancybox
 * @see {@link https://fancyapps.com/fancybox/3/}
 */
export default class MCGallery {
  constructor() {
    if (!$('[data-fancybox]').length || isOperaMini()) {
      return;
    }

    MCGallery.init();
  }

  static async init() {
    try {
      const isIE = window.document.documentMode;
      if (isIE) {
        await import('core-js/modules/es.array.iterator');
      }
      await import('../../vendors/libs/fancybox/dist/jquery.fancybox');

      $('[data-fancybox]').fancybox();
    } catch (error) {
      console.error(`An error was occured during initialization fancybox: ${error}`);
    }

    MCGallery.overrideSetTranslate();

    // Absolutely necessary to disable hash navigation as it doesn't play well with Citizens widgets
    MCGallery.disableHashNavigation();
    MCGallery.preserveFocus();
  }

  /**
   * @desc For cases when users navigates via keyboard to restore focus on the last focused lightbox-indicator
   */
  static preserveFocus() {
    let lastFocusedElement = null;

    $.fancybox.defaults.onInit = () => { lastFocusedElement = document.activeElement; };

    $.fancybox.defaults.afterClose = (instance) => {
      const $indicator = $(instance.$trigger).find('.js-mc-lightbox-indicator');
      const isIndicatorHadFocus = $indicator[0] === lastFocusedElement;

      if (isIndicatorHadFocus) {
        $indicator.focus();
      }
    };
  }

  /**
   * @desc Disables hash module
   */
  static disableHashNavigation() {
    $.fancybox.defaults.hash = false;
  }

  /**
   * @desc As on the end of 2019 Fancybox doesn't play well with RT languages.
   * Overriding default setTranslate we solve https://manchestercity.atlassian.net/browse/W30-608
   * The key idea is to invert X coordinate of css translate (see line where isRtl() ? -1 : 1).
   * @see {@link https://github.com/fancyapps/fancybox/issues/1210}
   */
  static overrideSetTranslate() {
    $.fancybox.setTranslate = function setTranslate($el, props) {
      let str = '';

      if (!$el || !props) {
        return;
      }

      if (props.left !== undefined || props.top !== undefined) {
        const xOffset = (props.left === undefined ? $el.position().left : props.left) * (isRtl() ? -1 : 1);
        const yOffset = props.top === undefined ? $el.position().top : props.top;

        str = `${xOffset}px, ${yOffset}px`;

        if (this.use3d) {
          str = `translate3d(${str}, 0px)`;
        } else {
          str = `translate(${str})`;
        }
      }

      if (props.scaleX !== undefined && props.scaleY !== undefined) {
        str += ` scale(${props.scaleX}, ${props.scaleY})`;
      } else if (props.scaleX !== undefined) {
        str += ` scaleX(${props.scaleX})`;
      }

      const css = {};

      if (str.length) {
        css.transform = str;
      }

      if (props.opacity !== undefined) {
        css.opacity = props.opacity;
      }

      if (props.width !== undefined) {
        css.width = props.width;
      }

      if (props.height !== undefined) {
        css.height = props.height;
      }

      // eslint-disable-next-line consistent-return
      return $el.css(css);
    };
  }
}
